import { InjectableClass } from '@fino/lib-injection';
import { AccountIdValidationService } from '../../domain/accountIdValidation.service';

export class BlzServiceProvider extends InjectableClass {
  constructor(validationRulesProvider, appCacheProvider) {
    'ngInject';
    super({ validationRulesProvider, appCacheProvider });

    this.activate();
  }

  $get() {
    'ngInject';
    return {};
  }

  activate() {
    this.validationRulesProvider.addRule('blz', (value) => {
      const { features } = this.appCacheProvider.get('config');
      const pattern = features.bankNumberValidation;
      return pattern
        ? AccountIdValidationService.fullfillsPattern(value, pattern)
        : true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/ui/account-number/blz.service.provider.js